<script>import CrossIcon from "../../icons/CrossIcon.svelte";
import { clickOutside } from "../../utils/clickOutside.js";
export let showModal;
export let modalSize = "";
export let dynamicWidth = "940px";
export let overflow = false;
let dialog;
export let title;
export let toggleModal;
$: if (showModal) {
  dialog?.showModal();
} else {
  dialog?.close();
}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->

<dialog
	class={`tw-shadow-[0px_8px_16px_0px_rgba(0,0,0,0.15)]} !tw-m-auto  tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-white tw-p-5`}
	style={`max-width: ${dynamicWidth}; overflow : ${overflow ? 'visible' : ""}`}
	use:clickOutside={()=>{}}
	bind:this={dialog}
	on:close={() => (showModal = false)}
	on:click|self={() => dialog.close()}
>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div class="modal fade show" style="display: block;" on:click|stopPropagation>
		<div class={`modal-dialog modal-${modalSize}`}>
			<div class="modal-content">
				<div
					class="modal-header flex tw-mb-4 tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-[#E7E7E7] tw-pb-4"
				>
					<h1
						class="modal-title d-inline fs-20 tw-font-inter tw-text-base tw-font-semibold tw-leading-6 tw-text-black"
					>
						{title}
					</h1>
					<!-- <slot>optional fallback</slot> -->
					<button
						type="button"
						class="btn-close"
						data-bs-dismiss="modal"
						aria-label="Close"
						on:click={(e) => toggleModal(e)}
					>
						<CrossIcon />
					</button>
				</div>
				<slot><!-- optional fallback --></slot>
			</div>
		</div>
	</div>
</dialog>

<style>
dialog::backdrop {
	background: rgba(0, 0, 0, 0.3);
}
dialog[open] {
	animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes zoom {
	from {
		transform: scale(0.95);
	}
	to {
		transform: scale(1);
	}
}
dialog[open]::backdrop {
	animation: fade 0.2s ease-out;
}
@keyframes fade {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
</style>
